import styles from "./PrivacyPolicy.module.css";

const PrivacyPolicyText = () => {
    return (
        <main className={styles.pages}>
            <h1>Privacy Policy</h1>

            <p>
                <strong>Effective Date: January 22, 2026</strong>
            </p>

            <section>
                <h2>General Privacy Policy</h2>

                <p>
                    Thank you for visiting askethos.ai (the “Site”), operated by Strategi Consulting, LLC (“us”, “we”, or “our”). This page informs you of our
                    you of our policies regarding the collection, use, and disclosure of information we receive from users of the Site.
                </p>

                <ol>
                    <li>
                        <strong>Information Collection and Use:</strong>
                        <ol>
                            <li>We do not collect personally identifiable information unless voluntarily provided.</li>
                            <li>Any voluntarily provided personal information is used only for its intended purpose.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>Log Data:</strong>
                        <ol>
                            <li>We may collect non-identifiable analytics such as IP address, browser type, timestamps, and aggregate statistics.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>Cookies:</strong>
                        <ol>
                            <li>Cookies may be used to improve user experience. You may disable cookies, but parts of the site may not function fully.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>Security:</strong>
                        <ol>
                            <li>We implement reasonable measures to prevent unauthorized access, alteration, or disclosure of personal information.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>Changes to This Privacy Policy:</strong>
                        <ol>
                            <li>This Policy is effective as of January 22, 2026.</li>
                            <li>Updates will be posted on this page and are effective immediately.</li>
                            <li>We reserve the right to update this Policy at any time.</li>
                            <li>Continued use of the Site constitutes acceptance of modifications.</li>
                        </ol>
                    </li>
                </ol>
            </section>
            <section>
                <h2>Ask Ethos AI-Driven Chatbot</h2>
                <p>
                    Ask Ethos uses Microsoft Azure OpenAI Service. Your use is subject to this Privacy Policy and the Microsoft Product and Services Data
                    Protection Addendum. Strategi Consulting, LLC is not responsible for Microsoft’s policies.
                </p>
                <ol>
                    <li>
                        <strong>Information Collected:</strong>
                        <ol>
                            <li>
                                <strong>User Input or Output Content:</strong>
                                <ul>
                                    <li>Logs may be used to improve system performance. They contain no personal information.</li>
                                </ul>
                            </li>

                            <li>
                                <strong>User Information:</strong>
                                <ul>
                                    <li>
                                        Non-personal usage patterns and session data are collected for analytics and optimization. for analytics and
                                        optimization.
                                    </li>
                                </ul>
                            </li>
                        </ol>
                    </li>

                    <li>
                        <strong>Data Storage and Security:</strong>
                        <ol>
                            <li>
                                <strong>Log Data:</strong>
                                <ul>
                                    <li>Chat logs are stored securely and accessible only to authorized personnel.</li>
                                </ul>
                            </li>

                            <li>
                                <strong>Security:</strong>
                                <ul>
                                    <li>
                                        We use reasonable safeguards; however, no transmission is completely secure. Microsoft may temporarily store data to
                                        detect abuse.
                                    </li>
                                </ul>
                            </li>
                        </ol>
                    </li>

                    <li>
                        <strong>Use of Information:</strong>
                        <ol>
                            <li>
                                <strong>Service Improvement:</strong>
                                <ul>
                                    <li>Used to enhance performance and functionality.</li>
                                    <li>Inputs/outputs are not shared with Microsoft or OpenAI for training.</li>
                                </ul>
                            </li>
                            <li>
                                <strong>Analytics:</strong>
                                <ul>
                                    <li>Used to understand behavior and optimize the system.</li>
                                </ul>
                            </li>

                            <li>
                                <strong>System Maintenance:</strong>
                                <ul>
                                    <li>Used for debugging, security, and reliability.</li>
                                </ul>
                            </li>
                        </ol>
                    </li>
                    <li>
                        <strong>Information Sharing:</strong>
                        <ol>
                            <li>
                                <strong>Third Parties:</strong>
                                <ul>
                                    <li>We do not share information except as legally required.</li>
                                </ul>
                            </li>

                            <li>
                                <strong>Aggregate Data:</strong>
                                <ul>
                                    <li>May be shared in anonymized form for research.</li>
                                </ul>
                            </li>
                        </ol>
                    </li>

                    <li>
                        <strong>Links to Other Websites:</strong>
                        <ol>
                            <li>We are not responsible for privacy practices of linked sites.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>Cookies and Tracking:</strong>
                        <ol>
                            <li>Used for authentication and session management.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>User Consent:</strong>
                        <ol>
                            <li>You may withdraw consent at any time.</li>
                            <li>You may disable cookies to opt out of non-essential data collection.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>Legal Compliance:</strong>
                        <ol>
                            <li>We comply with applicable privacy laws.</li>
                            <li>We use appropriate technical and organizational safeguards.</li>
                        </ol>
                    </li>

                    <li>
                        <strong>Changes to These Terms:</strong>
                        <ol>
                            <li>Updates will be posted, and are effective upon posting.</li>
                        </ol>
                    </li>
                </ol>
            </section>
            <section>
                <h2>Contact Us</h2>
                <p>
                    For questions, contact <a href="mailto:privacy@askethos.ai">privacy@askethos.ai</a>.
                </p>
            </section>
        </main>
    );
};

export default PrivacyPolicyText;
